import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useProgressCardStyles = makeThemedStyles(
  "InitiativeProgressCard",
  (theme) => ({
    container: {
      height: "330px",
      "& h3": {
        fontSize: "14px",
        color: "#656A72",
        lineHeight: "1.21em",
        fontWeight: 500,
      },
    },
  })
);

export default useProgressCardStyles;
